module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-wrapper"
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper",
    style: (_vm.headerStyle)
  }, [_c('input', {
    ref: "loadPreviewButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPreview
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "advantage-addition"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBondedLoanLetter(_vm.letterObject.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centered ispdf"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isPDF),
      callback: function($$v) {
        _vm.isPDF = $$v
      },
      expression: "isPDF"
    }
  }, [_vm._v("Это pdf")])], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": function($event) {
        return _vm.updateBondedLoanLetter(_vm.letter)
      }
    },
    model: {
      value: (_vm.letter.title),
      callback: function($$v) {
        _vm.$set(_vm.letter, "title", $$v)
      },
      expression: "letter.title"
    }
  })], 1), _vm._v(" "), (this.letter.type === 'pdf') ? _c('div', [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPreview
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить превью\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [(!_vm.letterObject.file) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleloadDocument
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить документ\n          ")]) : _c('span', {
    staticClass: "rates-file"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": '/' + _vm.letterObject.file
    }
  }, [_vm._v("\n              Просмотреть документ\n            ")]), _vm._v(" "), _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.deleteFile
    }
  })]), _vm._v(" "), _c('input', {
    ref: "loadDocumentButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadDocument
    }
  })])]) : _c('div', [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPreview
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото\n          ")])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0187e1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/Letter.vue
// module id = 990
// module chunks = 0